import { readable } from 'svelte/store';

// Shared ticking clock for season/cooldown gating so time-based UI flips
// while the page stays open (e.g. the daily-bonus cooldown expiring, or the
// claim window closing). 5s resolution is enough for gating — the Countdown
// component handles per-second display on its own.
export const now = readable(Date.now(), (set) => {
    const interval = setInterval(() => set(Date.now()), 5000);
    return () => clearInterval(interval);
});
